<div class="mode-file-upload-container">
  <div
    class="mode-file-upload"
    [class.mode-file-upload--disabled]="disabled"
    [class.mode-file-upload--dragover]="isDragOver"
    [class.mode-file-upload--modal]="showAsModal"
    (drop)="onFileDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    data-testid="file-upload-container"
  >
    <div class="mode-file-upload__drop-zone" *ngIf="config?.dropZone" (click)="fileInput.click()">
      <div class="mode-file-upload__drop-zone-content">
        <capra-icon
          [icon]="currentlySelectedFile ? uploadIcon : 'illo-upload-file'"
          class="mode-file-upload__icon"
        ></capra-icon>
        <p class="mode-file-upload__message">
          {{
            !currentlySelectedFile ? dragMessage || defaultDragMessage : currentlySelectedFile.name || 'File selected'
          }}
          <br />
          <a
            type="button"
            class="mode-file-upload__link-button"
            [disabled]="disabled"
            [attr.data-testid]="currentlySelectedFile ? 'file-replace-button' : 'file-select-button'"
            (click)="onImportButtonClick($event)"
          >
            {{
              currentlySelectedFile
                ? selectedFileButtonText || 'Click here to replace the file'
                : selectButtonText || 'Select File'
            }}
          </a>
        </p>
        <p class="mode-file-upload__format-description" *ngIf="formatDescription">
          File formats compatible: {{ formatDescription }}
        </p>
        <p class="mode-file-upload__max-size" *ngIf="showMaxFileSize && config?.maxSize">
          Maximum file size: {{ formatFileSize(config.maxSize) }}
        </p>
      </div>
    </div>

    <input
      #fileInput
      type="file"
      class="mode-file-upload__input"
      [accept]="acceptedTypesString"
      [multiple]="config?.multiple"
      [disabled]="disabled"
      (change)="onFileSelect($event)"
      data-testid="file-input"
      hidden
    />
  </div>
</div>
